export const GEO_ID = 'address';
export const PRICE_ID = 'price-and-deal-terms';
export const PHOTOS_ID = 'description-and-photos';
export const PUBLISH_TERMS_ID = 'ad-placing-terms';
export const SERVICES_SLIDER_ID = 'publish-terms-services-slider';
export const TERMS_DURATIONS_SLIDER_ID = 'publish-terms-durations-slider';
export const PROMOTION_SECTION_ID = 'promotion-section';
